if (!customElements.get("finder-tyre")) {
  customElements.define(
    "finder-tyre",
    class YearSearch extends HTMLElement {
      constructor() {
        super();
        this.getFilterURL = "";
        this.widthFilter = this.querySelector(".select__width_data");
        this.widthFilter?.addEventListener("change", this.getRatioData.bind(this));
        this.ratioStoreData = "";
        this.ratioFilter = this.querySelector(".select__ratio_data");
        this.ratioFilter?.addEventListener("change", this.getDiameterData.bind(this));
        this.diameterStoreData = "";
        this.diameterFilter = this.querySelector(".select__diameter_data");
        this.diameterFilter.disabled = true; // Ensure disabled on initialization
        this.searchURL = this.querySelector(".search__url");
        this.initWidthFilter();
      }

      resetDropdown(dropdown, placeholder) {
        dropdown.innerHTML = `<option value="select">${placeholder}</option>`;
        dropdown.disabled = true;
      }

      disableSearchLink() {
        this.searchURL.removeAttribute("href");
        this.searchURL.setAttribute("disabled", "true");
        this.searchURL.classList.add("disabled");
      }

      enableSearchLink(url) {
        this.searchURL.setAttribute("href", url);
        this.searchURL.removeAttribute("disabled");
        this.searchURL.classList.remove("disabled");
      }

      initWidthFilter() {
        fetch(`${tyreURL}?view=search.finder-tyre`)
          .then((response) => response.text())
          .then((response) => {
            let parser = new DOMParser(),
              newHTMlData = parser.parseFromString(response, "text/html"),
              getSelectValues = newHTMlData.querySelector(".select__width_data"),
              uniqueSelectDataList = [];

            for (let i = 0, n = getSelectValues.options.length; i < n; i++) {
              if (getSelectValues.options[i].value)
                uniqueSelectDataList.push(getSelectValues.options[i].value);
            }

            let uniqueDataArray = [...new Set(uniqueSelectDataList)];

            let initialData = `<option value="select">Tyre Width</option>`;
            uniqueDataArray.forEach((option) => {
              initialData += `<option value="${option}">${option}</option>`;
            });

            this.widthFilter.innerHTML = initialData;
          })
          .catch((err) => console.log("Error initializing width filter:", err));
      }

      getRatioData() {
        const selectWidthValue = this.widthFilter.options[this.widthFilter.selectedIndex].value;

        if (selectWidthValue === "select") {
          this.disableSearchLink();
          this.resetDropdown(this.ratioFilter, "Tyre Ratio");
          this.resetDropdown(this.diameterFilter, "Tyre Diameter");
        } else {
          this.ratioStoreData = selectWidthValue;
          this.getFilterURL = `${tyreURL}?filter.p.m.tyre-size.width=${this.ratioStoreData}`;
          this.enableSearchLink(this.getFilterURL);

          fetch(
            `${tyreURL}?filter.p.m.tyre-size.width=${this.ratioStoreData}&view=search.finder-tyre`
          )
            .then((response) => response.text())
            .then((response) => {
              let parser = new DOMParser(),
                newHTMlData = parser.parseFromString(response, "text/html"),
                getSelectValues = newHTMlData.querySelector(".select__ratio_data"),
                uniqueSelectDataList = [];

              for (let i = 0, n = getSelectValues.options.length; i < n; i++) {
                if (getSelectValues.options[i].value)
                  uniqueSelectDataList.push(getSelectValues.options[i].value);
              }

              let uniqueDataArray = [...new Set(uniqueSelectDataList)];

              let initialData = `<option value="select">Tyre Ratio</option>`;
              uniqueDataArray.forEach((option) => {
                initialData += `<option value="${option}">${option}</option>`;
              });

              if (this.ratioFilter) {
                this.ratioFilter.innerHTML = initialData;
                this.ratioFilter.disabled = false;
              }
            })
            .catch((err) => console.log("Error fetching ratio data:", err));
        }
      }


      getDiameterData(e) {
        let selectRatioValue =
          this.ratioFilter.options[this.ratioFilter.selectedIndex].value;
        
        // If "select" option is chosen, reset and disable dependent elements
        if (selectRatioValue === "select") {
          this.disableSearchLink();
          this.resetDropdown(this.diameterFilter, "Tyre Diameter");
        } else {
          // Update the diameterStoreData with selected make value
          this.diameterStoreData = selectRatioValue;
          this.getFilterURL = `${tyreURL}?filter.p.m.tyre-size.ratio=${selectRatioValue}&filter.p.m.tyre-size.width=${this.ratioStoreData}`;
          
          // Enable the search link with current URL
          this.enableSearchLink(this.getFilterURL);
      
          // Fetch and populate the diameter dropdown
          fetch(
            `${tyreURL}?filter.p.m.tyre-size.ratio=${selectRatioValue}&filter.p.m.tyre-size.width=${this.ratioStoreData}&view=search.finder-tyre`
          )
            .then((response) => response.text())
            .then((response) => {
              let parser = new DOMParser(),
                newHTMlData = parser.parseFromString(response, "text/html"),
                getSelectValues = newHTMlData.querySelector(".select__diameter_data"),
                uniqueSelectDataList = [];
      
              // Collect and filter unique diameter options
              for (var i = 0, n = getSelectValues.options.length; i < n; i++) {
                if (getSelectValues.options[i].value)
                  uniqueSelectDataList.push(getSelectValues.options[i].value);
              }
      
              let uniqueDataArray = uniqueSelectDataList.filter(
                (item, index, arr) => arr.indexOf(item) == index
              );
      
              // Create dropdown options for diameters
              let initialData = `<option value="select">Tyre Diameter</option>`;
              uniqueDataArray.forEach((option) => {
                initialData += `<option value="${option}">${option}</option>`;
              });
      
              // Populate and enable the diameter filter dropdown
              if (this.diameterFilter !== null) {
                this.diameterFilter.innerHTML = initialData;
                this.diameterFilter.disabled = false;
      
                // Add event listener for final selection to trigger URL update
                this.diameterFilter.addEventListener("change", () => {
                  let selectDiameterValue =
                    this.diameterFilter.options[this.diameterFilter.selectedIndex].value;
      
                  if (selectDiameterValue !== "select") {
                    this.getFilterURL = `${tyreURL}?filter.p.m.tyre-size.diameter=${selectDiameterValue}&filter.p.m.tyre-size.ratio=${this.diameterStoreData}&filter.p.m.tyre-size.width=${this.ratioStoreData}`;
                    this.enableSearchLink(this.getFilterURL);
                  } else {
                    this.disableSearchLink();
                  }
                });
              }
            })
            .catch((err) => console.log(err));
        }
      } 
    }
  );
}